<ion-app>
    <sah-mobile-header *ngIf="isLoggedIn$ | ngrxPush"></sah-mobile-header>
    <sah-mobile-menu></sah-mobile-menu>

    <ion-content id="main">
        <router-outlet></router-outlet>
    </ion-content>
</ion-app>
